<template>
  <a :href="facebookUrl" target="_blank" rel="noopener noreferrer">
    <span class="icon is-small">
      <i class="mdi mdi-facebook"></i>
    </span>
  </a>
</template>

<script>
export default {
  name: 'facebookLink',
  props: {
    facebookPageName: {
      type: String,
      default: ''
    }
  },
  computed: {
    facebookUrl () {
      return `https://facebook.com/${this.facebookPageName}`
    }
  }
}
</script>

<style>

</style>
